module.exports = __webpack_public_path__ + "static/media/carousel_en_credibility.fa6be4df.jpg";